import { call, put, select } from 'redux-saga/effects';

import { extractErrorMessage, sendToLogger } from 'connect/saga/helpers';

import { selectDataUserAuthenticated } from 'connect/selectors';
import { makeRequest } from 'utils/request';

import { SagaHandler } from '../SagaHandler';

const apiGetReceivedOffers = async () =>
  makeRequest({
    url: `${CONFIG.API_URL}/offerClaim/received`,
    method: 'GET',
  });

class _ReceivedOffers extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/RECEIVED_OFFERS',
      stateKey: 'receivedOffers',
    });
  }

  * saga() {
    const isUserAuthenticated = yield select(selectDataUserAuthenticated);
    if (!isUserAuthenticated) {
      return;
    }

    const errorHandler = this.error;
    const loadingHandler = this.loading;
    const valueHandler = this.value;

    try {
      yield put(loadingHandler.update(true));
      yield put(errorHandler.update(null));
      const receivedOffers = yield call(apiGetReceivedOffers);
      yield put(valueHandler.update(receivedOffers));
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      sendToLogger(error, 'receivedOffers');
      yield put(errorHandler.update(errorMessage));
    } finally {
      yield put(loadingHandler.update(false));
    }
  }
}

export const ReceivedOffers = new _ReceivedOffers();
